import React from 'react';

const Footer = () => (
  <footer>
    <p>&copy; {new Date().getFullYear()} Azhagarasan Murali</p>
  </footer>
);

export default Footer;
